// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
 
import { environmentRoot } from "../environments/roots/environments.roots";
 
export const environment = {
  root: environmentRoot,
 
  WebApiURL: 'https://cmpfe-api-dev.azure.chevron.com',
  chatbotUrl: 'https://cmpfe-chatbot-dev.azurewebsites.net',
  autoSignIn: true,
  environmentTag: 'DEV',
  production: false,
  redirectUri: 'https://cmpfe-dev.azure.chevron.com/' ,
 

};
 
/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
 